import { jsx as _jsx } from "react/jsx-runtime";
import { Center, forwardRef, useBreakpointValue, useColorMode, } from '@chakra-ui/react';
import { theme } from '../../modules/theme';
import { STATUSES_TO_COLOR_SCHEME, STATUSES_TO_ICON } from '../internal/Status';
export const IconStatus = forwardRef(({ size: responsiveSize = theme.sizes['4'], status, ...props }, ref) => {
    const { colorMode } = useColorMode();
    const size = useBreakpointValue(responsiveSize) ?? responsiveSize;
    return (_jsx(Center, { ref: ref, background: theme.colors[colorMode].support[STATUSES_TO_COLOR_SCHEME[status]][4], color: theme.colors[colorMode].support[STATUSES_TO_COLOR_SCHEME[status]][1], borderRadius: "50%", w: size, h: size, sx: {
            svg: {
                fontSize: `calc(${size} * 0.7)`,
            },
        }, flexShrink: 0, ...props, children: STATUSES_TO_ICON[status] }));
});
